import React from "react";
import "./ContentPage.css";

const ConsentPolicy = () => {
  return (
    <main className="content-page">
      <section className="content-hero">
        <div className="content-hero-inner">
          <span className="cb-section-label">Legal</span>
          <h1>Consent Policy</h1>
          <p>Loan application and communication authorization for Core Bankers services.</p>
        </div>
      </section>

      <div className="content-body">
        <section className="content-section">
          <h2>1. Purpose of Consent</h2>
          <p>By submitting your details on Core Bankers, you authorize our team and partners to:</p>
          <ul>
            <li>Evaluate loan eligibility and recommend financial products</li>
            <li>Share your info securely with partnered banks and NBFCs</li>
            <li>Facilitate disbursement, documentation, and loan servicing</li>
            <li>Send promotional offers related to financial services</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>2. Types of Data We Collect</h2>
          <ul>
            <li>Personal Information: Name, PAN, Aadhaar, DOB</li>
            <li>Contact: Phone number, email, and address</li>
            <li>Financial: Income, employment, business details</li>
            <li>Uploads: Documents like salary slips, bank statements</li>
            <li>Credit Reports (only after your permission)</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>3. Data Sharing</h2>
          <p>We may share data with:</p>
          <ul>
            <li>Financial partners for loan processing</li>
            <li>Credit bureaus for evaluation</li>
            <li>Verified service providers for document handling</li>
          </ul>
          <p style={{ marginTop: "0.75rem" }}>
            <strong>We never sell your data.</strong>
          </p>
        </section>

        <section className="content-section">
          <h2>4. Communication & Promotion</h2>
          <p>You agree to receive communications via call, SMS, WhatsApp, Email, or RCS regarding your application, offers, or new financial products. You may opt out anytime by writing to{" "}
            <a href="mailto:Manager@CoreBankers.In">Manager@CoreBankers.In</a>.
          </p>
        </section>

        <section className="content-section">
          <h2>5. Data Retention & Withdrawal</h2>
          <ul>
            <li>We retain data only as long as required legally</li>
            <li>You can request deletion or withdraw consent anytime via email</li>
            <li>We comply with data regulation guidelines when processing requests</li>
          </ul>
        </section>

        <section className="content-section">
          <h2>6. Legal Acknowledgment</h2>
          <p>By using our platform, you:</p>
          <ul>
            <li>Confirm your data is accurate and voluntarily shared</li>
            <li>Acknowledge the policy above and agree to it in full</li>
          </ul>
        </section>

        <div className="content-contact">
          <a href="mailto:Manager@CoreBankers.In">Manager@CoreBankers.In</a>
          <br />
          +91 86394 15052
        </div>
      </div>
    </main>
  );
};

export default ConsentPolicy;
